var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"white","height":"100vh","display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"}},[_c('div',{staticStyle:{"width":"5%"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../../assets/images/loading.gif")}})])])
}]

export { render, staticRenderFns }